<div *ngIf="isLoading" class="loading-overlay">
  <mat-spinner [diameter]="40" [strokeWidth]="5"></mat-spinner>
</div>
<section class="pb-9">
  <div class="search-component container">
    <div class="flex-box">
      <h3 class="heading">{{ 'SEARCH' | translate }}</h3>
      <h3 class="heading ml-29">{{ 'SEARCH_BY_IMAGE' | translate }}</h3>
    </div>
    <hr class="rule" />

    <div class="form-area">
      <div class="form-box">
        <div >
          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>{{ 'INVOICE' | translate }}</mat-label>
              <input matInput [formControl]="invoiceNumber"  (input)="invoiceNumberValidation()"/>
            </mat-form-field>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="tune" class="icon"
              (click)="openDialog('invoiceNo')"></mat-icon>
            <div class="mat-field-custom-error">
              <mat-error *ngIf="invoiceNumberFormatValidation">{{'ERR_INV_MSG_TL' | translate }}</mat-error>
             
            </div>   
          </div>              
        </div>     

        <div class="advance-option-field">
          <mat-form-field appearance="outline" class="text-field">
            <mat-label>{{ 'CUSTOMER'| translate}}</mat-label>
            <input matInput [formControl]="customerNumber" (input)="customerNumberValidation()" />
          </mat-form-field>
          <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="tune" class="icon"
            (click)="openDialog('cutomerNo')"></mat-icon>
          <div class="mat-field-custom-error">
            <mat-error *ngIf="customerNumberFormatValidation">{{'ERR_ACCT_MSG_TL' | translate }}</mat-error>
          </div>   
        </div>

        <div class="advance-option-field">
          <mat-form-field appearance="outline" class="text-field">
            <mat-label>{{ 'PIN' |  translate}}</mat-label>
            <input matInput [formControl]="pinNumber" (input)="onPinChange()"/>
          </mat-form-field>
          <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="tune" class="icon"
            (click)="openDialog('pin')"></mat-icon>
            <div class="mat-field-custom-error">
              <mat-error *ngIf="pinNumberValidation">{{'ERR_PIN_MSG_TL' | translate }}</mat-error>
            </div>
            <mat-checkbox *ngIf="showPinCheckbox" [formControl]="pinSearchCheckbox" color="primary">Pin Search</mat-checkbox>
        </div>

        <div [formGroup]="dateFormGroup">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'FROM' | translate }}</mat-label>
            <input matInput [max]="todayDate" [matDatepicker]="fromPicker" formControlName="fromDate" />
            <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="date-picker">
            <mat-label>{{ 'TO' | translate }}</mat-label>
            <input matInput [min]="getFromDate()" [max]="todayDate" [matDatepicker]="toPicker"
              formControlName="toDate" />
            <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
          </mat-form-field>
          <mat-error *ngIf="dateRequiredValidation" class="mat-field-date-custom-error">
           {{'DATA_RANGE_REQ'| translate}}
          </mat-error>
          <mat-error *ngIf="requiredFieldValidation" class="mat-field-date-custom-error">
            {{'SEARCH_VALID_ERROR'|translate}}
          </mat-error>
          <mat-error *ngIf="dateFormGroup.hasError('dateRangeExceedsOneYear')" class="mat-field-date-custom-error">
            {{'DATE_RANGE_ERROR'|translate}}
          </mat-error>
        </div>

        

        <div class="action-bar">
          <button class="action-btn" (click)="searchResults('invoice', true)" [disabled]="dateFormGroup.invalid">{{ 'SEARCH' | translate }}</button>
          <button class="action-btn" (click)="clearInput()">{{ 'RESET_INPUT' | translate }}</button>
          <button class="action-btn" (click)="clearDate()">{{ 'CLEAR_DATES' | translate }}</button>
        </div>
        
      </div>

      <div class="form-box">
        <div class="right-form-box-element advance-option-field ml-auto">
          <mat-form-field appearance="outline" class="text-field">
            <mat-label>{{ 'PIN' | translate}}</mat-label>
            <input matInput [formControl]="pinNumberByImage" (input)="onPinNumberChange()"/>
          </mat-form-field>

          <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="tune" class="icon"
            (click)="openDialog('imagePin')"></mat-icon>
           <div class="mat-field-image-custom-error">
              <mat-error *ngIf="pinNumberImageValidation">{{'ERR_PIN_MSG_TL' | translate }}</mat-error>
            </div>
        </div>

        <div class="radio-group-box" [formGroup]="radioFormGroup">
          <mat-radio-group aria-label="Select an option" formControlName="options" [formControl]="isDataCompleted">
            <mat-radio-button value="1" color="primary">{{ 'DATA_COMPLETED' | translate }}</mat-radio-button>
            <mat-radio-button value="2" color="primary">{{ 'NOT_COMPLETED' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="mt-auto">
          
          
         <mat-error *ngIf="!searchByImageFormValidation" class="error-line ml-45">
          {{'MISSING_FIELD' | translate }}
          </mat-error> 

          <div class="action-bar ml-45">
            <button class="action-btn" (click)="searchByImageResults()">
              {{'SEARCH' | translate }}
            </button>
            <button class="action-btn" (click)="clearInputByImage()">
              {{ 'RESET_INPUT' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="result-section" class="container mb-9">
    <paginated-table [tableData]="dataSource" [message]="emptyTableData" (callbackFunction)="clearInput()" [nextToken]="next_token"
      (loadMore)="loadNextPage($event)">
    </paginated-table>
  </div>
</section>
